import { createAction, props } from '@ngrx/store';
import { CompanyAttribute, FieldValidationError, HierarchyDto, OrganisationGroupModel, User } from '../../shared/models';

export enum Type {
  ORGANIZATION_TREE_TABLE_LOADING = '[ORGANIZATION] ORGANIZATION_TREE_TABLE_LOADING',
  ORGANIZATION_TREE_TABLE_LOADING_COMPLETE = '[ORGANIZATION] ORGANIZATION_TREE_TABLE_LOADING_COMPLETE',
  USER_TABLE_LOADING = '[ORGANIZATION] USER_TABLE_LOADING',
  USER_TABLE_LOADING_COMPLETE = '[ORGANIZATION] USER_TABLE_LOADING_COMPLETE',
  DELETED_GROUPS_TABLE_LOADING = '[ORGANIZATION] DELETED_GROUPS_TABLE_LOADING',
  DELETED_GROUPS_TABLE_LOADING_COMPLETE = '[ORGANIZATION] DELETED_GROUPS_TABLE_LOADING_COMPLETE',
  SET_DELETED_GROUPS_COUNT = '[ORGANIZATION] SET_DELETED_GROUPS_COUNT',
  SET_ORPHAN_GROUPS_COUNT = '[ORGANIZATION] SET_ORPHAN_GROUPS_COUNT',
  ORPHAN_GROUPS_TABLE_LOADING = '[ORGANIZATION] ORPHAN_GROUPS_TABLE_LOADING',
  ORPHAN_GROUPS_TABLE_LOADING_COMPLETE = '[ORGANIZATION] ORPHAN_GROUPS_TABLE_LOADING_COMPLETE',
  FETCH_USERS = '[ORGANIZATION] FETCH_USERS',
  FETCH_USERS_SUCCESS = '[ORGANIZATION] FETCH_USERS_SUCCESS',
  FETCH_USERS_ERROR = '[ORGANIZATION] FETCH_USERS_ERROR',
  FETCH_GROUP_USERS = '[ORGANIZATION] FETCH_GROUP_USERS',
  SELECT_USERS = '[ORGANIZATION] SELECT_USERS',
  DESELECT_USERS = '[ORGANIZATION] DESELECT_USERS',
  FETCH_TREE = '[ORGANIZATION] FETCH_TREE',
  FETCH_TREE_SUCCESS = '[ORGANIZATION] FETCH_TREE_SUCCESS',
  FETCH_TREE_ERROR = '[ORGANIZATION] FETCH_TREE_ERROR',
  FETCH_COMPANY_ATTRIBUTES = '[ORGANIZATION] FETCH_COMPANY_ATTRIBUTES',
  FETCH_COMPANY_ATTRIBUTES_SUCCESS = '[ORGANIZATION] FETCH_COMPANY_ATTRIBUTES_SUCCESS',
  FETCH_COMPANY_ATTRIBUTES_ERROR = '[ORGANIZATION] FETCH_COMPANY_ATTRIBUTES_ERROR',
  VALIDATE_USER = '[ORGANIZATION] VALIDATE_USER',
  VALIDATE_USER_SUCCESS = '[ORGANIZATION] VALIDATE_USER_SUCCESS',
  VALIDATE_USER_FAILED = '[ORGANIZATION] VALIDATE_USER_FAILED',
  VALIDATE_USER_ERROR = '[ORGANIZATION] VALIDATE_USER_ERROR',
  ADD_USER = '[ORGANIZATION] ADD_USER',
  ADD_USER_SUCCESS = '[ORGANIZATION] ADD_USER_SUCCESS',
  ADD_USER_ERROR = '[ORGANIZATION] ADD_USER_ERROR',
  EDIT_USER = '[ORGANIZATION] EDIT_USER',
  EDIT_USER_SUCCESS = '[ORGANIZATION] EDIT_USER_SUCCESS',
  EDIT_USER_ERROR = '[ORGANIZATION] EDIT_USER_ERROR',
  SELECT_GROUPS = '[ORGANIZATION] SELECT_GROUPS',
  DESELECT_GROUPS = '[ORGANIZATION] DESELECT_GROUPS',
  SELECT_HIERARCHY = '[ORGANIZATION] SELECT_HIERARCHY'
}

// Loading Actions (No Payload)
export const OrganizationTreeTableLoading = createAction(Type.ORGANIZATION_TREE_TABLE_LOADING);
export const OrganizationTreeTableLoadingComplete = createAction(Type.ORGANIZATION_TREE_TABLE_LOADING_COMPLETE);
export const UserTableLoading = createAction(Type.USER_TABLE_LOADING);
export const UserTableLoadingComplete = createAction(Type.USER_TABLE_LOADING_COMPLETE);
export const DeletedGroupsTableLoading = createAction(Type.DELETED_GROUPS_TABLE_LOADING);
export const DeletedGroupsTableLoadingComplete = createAction(Type.DELETED_GROUPS_TABLE_LOADING_COMPLETE);
export const OrphanGroupsTableLoading = createAction(Type.ORPHAN_GROUPS_TABLE_LOADING);
export const OrphanGroupsTableLoadingComplete = createAction(Type.ORPHAN_GROUPS_TABLE_LOADING_COMPLETE);

// Actions with Payloads
export const SetDeletedGroupsCount = createAction(
  Type.SET_DELETED_GROUPS_COUNT,
  props<{ payload: number }>()
);

export const SetOrphanGroupsCount = createAction(
  Type.SET_ORPHAN_GROUPS_COUNT,
  props<{ payload: number }>()
);

export const fetchUsers = createAction(Type.FETCH_USERS);

export const fetchUsersSuccess = createAction(
  Type.FETCH_USERS_SUCCESS,
  props<{ users: User[] }>()
);

export const fetchUsersError = createAction(
  Type.FETCH_USERS_ERROR,
  props<{ error: string }>()
);

export const fetchGroupUsers = createAction(
  Type.FETCH_GROUP_USERS,
  props<{ companyId: number; groupId: number }>()
);

export const selectUsers = createAction(
  Type.SELECT_USERS,
  props<{ ids: number[] }>()
);

export const deselectUsers = createAction(
  Type.DESELECT_USERS,
  props<{ ids: number[] }>()
);

export const fetchTree = createAction(
  Type.FETCH_TREE, 
  props<{ companyId: number }>()
);

export const fetchTreeSuccess = createAction(
  Type.FETCH_TREE_SUCCESS,
  props<{ tree: HierarchyDto<OrganisationGroupModel>[] }>()
);

export const fetchTreeError = createAction(
  Type.FETCH_TREE_ERROR,
  props<{ error: string }>()
);

export const fetchCompanyAttributes = createAction(
  Type.FETCH_COMPANY_ATTRIBUTES, 
  props<{ companyId: number }>()
);

export const fetchCompanyAttributesSuccess = createAction(
  Type.FETCH_COMPANY_ATTRIBUTES_SUCCESS,
  props<{ attributes: CompanyAttribute[] }>()
);

export const fetchCompanyAttributesError = createAction(
  Type.FETCH_COMPANY_ATTRIBUTES_ERROR,
  props<{ error: string }>()
);

export const validateUser = createAction(
  Type.VALIDATE_USER, 
  props<{ user: User }>()
);

export const validateUserFailed = createAction(
  Type.VALIDATE_USER_FAILED,
  props<{ fields: FieldValidationError[] }>()
);

export const validateUserSuccess = createAction(
  Type.VALIDATE_USER_SUCCESS,
  props<{ fields: FieldValidationError[] }>()
);

export const validateUserError = createAction(
  Type.VALIDATE_USER_ERROR,
  props<{ error: string }>()
);

export const addUser = createAction(
  Type.ADD_USER, 
  props<{ user: User }>()
);

export const addUserSuccess = createAction(
  Type.ADD_USER_SUCCESS,
  props<{ user: User }>()
);

export const addUserError = createAction(
  Type.ADD_USER_ERROR,
  props<{ error: string }>()
);

export const editUser = createAction(
  Type.EDIT_USER, 
  props<{ user: User }>()
);

export const editUserSuccess = createAction(
  Type.EDIT_USER_SUCCESS,
  props<{ user: User }>()
);

export const editUserError = createAction(
  Type.EDIT_USER_ERROR,
  props<{ error: string }>()
);

export const selectGroups = createAction(
  Type.SELECT_GROUPS,
  props<{ ids: number[] }>()
);

export const deselectGroups = createAction(
  Type.DESELECT_GROUPS,
  props<{ ids: number[] }>()
);

export const selectHierarchy = createAction(
  Type.SELECT_HIERARCHY,
  props<{ id: number }>()
);